import useBundleTranslation from 'i18n';
import { useAppBuilderContext } from 'app/app/editor/context';
import { Box, MenuItem } from '@mui/material';
import { IMenuItem } from 'app/app/editor/tabs/elements/layout/context-menu/index';
import styles from 'app/app/editor/tabs/elements/layout/context-menu/ContextMenu.styles';
import IconMi from 'components/common/icon/IconMi';
import insertNodeIntoPage from 'app/app/editor/page/insertNodeIntoPage';
import { getDefaultsFields, processPageContainersUid } from 'app/app/editor/page';
import insertComponentIntoPage from 'app/app/editor/page/insertComponentIntoPage';
import { formAPI } from 'api/form';

export default function MenuAddMenuContainer({ openWithUid, handleClose }: IMenuItem) {
    const { t } = useBundleTranslation(['app/portal-page-builder']);
    const ctx = useAppBuilderContext();

    if (openWithUid != 'page') {
        return null;
    }

    const disabled = ctx.page.layout?.elements?.findIndex((node) => node.subtype == 'page_menu') != -1;

    return (
        <MenuItem
            disabled={disabled}
            onClick={() => {
                let parent = ctx.page.layout;

                // let newPage = insertNodeIntoPage(
                //     ctx.page,
                //     { type: 'container', params: { uid: '__mark' }, elements: structuredClone(parent.elements) },
                //     parent.params.uid,
                //     openWithUid,
                // );
                // processPageContainersUid(newPage.layout, 'container');
                //
                // newPage.layout.elements = newPage.layout.elements?.filter((node, index) => node.params.uid == '__mark');
                // const containerNode = getNodeByUid(newPage.layout, '__mark');
                // if (containerNode) {
                //     containerNode.params.uid = parent.params.uid + '-0__mark';
                // }
                // processPageContainersUid(newPage.layout, 'container');

                let container = insertNodeIntoPage(
                    ctx.page,
                    {
                        type: 'container',
                        subtype: 'page_menu',
                        params: {
                            uid: parent.params.uid + '-0__mark',
                            layout: {
                                width: '224px',
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 'auto',
                                bottom: 0,
                                resize: 'horizontal',
                                margin: '0',
                                padding: '36px 12px 12px 12px',
                                backgroundColor: '#ffffff',
                                'menu-collapse-type': 'x',
                                'size-type-width': 'fixed',
                            },
                        },
                    },
                    parent.params.uid,
                    openWithUid,
                );
                processPageContainersUid(container.layout, 'container');
                ctx.setPage(container, false);
                const menuContainerUid = container.layout.elements?.find((e) => e?.subtype === 'page_menu')?.params
                    ?.uid;
                if (!menuContainerUid) {
                    console.error('Menu container UID not found after insertion');
                    handleClose();
                    return;
                }
                const path = [`mi-app-${parent.params.uid}`, `mi-app-${menuContainerUid}`];

                const folderMenu = 'folder-menu';

                const { newPage } = insertComponentIntoPage(container, folderMenu, path, '');
                formAPI
                    .load('/data/app/components/' + folderMenu + '/form.json')
                    .then((response: any) => {
                        if (response.data?.fields) {
                            newPage.components[folderMenu].settings = getDefaultsFields(response.data.fields);
                        }
                        ctx.setPage(newPage, false);
                        ctx.sendMessage({ name: 'reloadPage' });
                        handleClose();
                    })
                    .catch((error: any) => {
                        console.error('Failed to load form data for folder-menu:', error);
                        ctx.setPage(newPage, false);
                        ctx.sendMessage({ name: 'reloadPage' });
                        handleClose();
                    });
            }}
        >
            <Box sx={styles.iconHolder}>
                <IconMi icon={'sidebar-menu'} />
            </Box>
            <Box>{t('node_context_menu.add_menu_container')}</Box>
        </MenuItem>
    );
}
